import Striped_Pattern_Drop_Shoulder_Jumper2 from '../image/products/Striped_Pattern_Drop_Shoulder_Jumper2.webp';
import Striped_Pattern_Drop_Shoulder_Jumper3 from '../image/products/Striped_Pattern_Drop_Shoulder_Jumper3.webp';
import Max_Smartwatch_For_Man_Sports_Woman_Fitness_Original from '../image/products/Max-Smartwatch-For-Man-Sports-Woman-Fitness-Original.webp';
import Apple_AirPods_Pro from '../image/products/61f1YfTkTDL._AC_SX466_.jpg';
import Aquasonic_Black_Series_Ultra_Whitening_Toothbrush from '../image/products/71BWLH21E2L._SX425_.jpg';
import REVLON_One_Step_Volumizer from '../image/products/71aXzv34N+L._SX425_.jpg';
import Safety_1st_Grow_and_Go from '../image/products/91qlJfSuMNL._SX425_.jpg';
import Bedsure_Dark_Grey_Duvet_Cover_Queen_Size from '../image/products/810CAfisn2L._AC_SX679_.jpg';
import Afloia_Air_Purifiers from '../image/products/71H5IWsuetL._AC_SX569_.jpg';
import INSE_Cordless_Vacuum_Cleaner from '../image/products/6102W81oNBL._AC_SX679_.jpg';
import Doctors_Recipes_Womens_Probiotic from '../image/products/61dMV893n5S._AC_SX569_.jpg';
import Wireless_Charger_Hicober from '../image/products/71Aar+waY1L._AC_SX679_.jpg';
import THERUN_Under_Desk_Treadmill from '../image/products/61vPiB+IxOL._AC_SX569_.jpg';

const UPDATE_NEW_SEARCH_TEXT = 'UPDATE-NEW-SEARCH-TEXT';
const ADD_MESSAGE = 'ADD-MESSAGE';
// const { productsData } = await import('./data');
const { productsData } = require("./data");


const UPDATE_NEW_MESSAGE_TEXT = 'UPDATE-NEW-MESSAGE-TEXT';

let initialState = {
  productsData,
  newSearchText: '',
};

const messagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_MESSAGE:
      let newMessage = {
        id: 6,
        message: state.newMessageText,
        isItYou: true,
      };
      return {
        ...state,
        newMessageText: '',
        messagesData: [...state.messagesData, newMessage],
      };
    case UPDATE_NEW_SEARCH_TEXT:
      return {
        ...state,
        newSearchText: action.newText,
      };
    default:
      return state;
  }
};

export const addMessageActionCreator = () => ({ type: ADD_MESSAGE });

export const updateNewSearchTextActionCreator = (text) => ({
  type: UPDATE_NEW_SEARCH_TEXT,
  newText: text,
});

export default messagesReducer;
